var $ = require('jquery');
import { gsap } from "gsap";

$('.carousel-slides').each(function() {
    
    var _this = $(this);
    
    var cardWidth = Math.round(parseFloat(_this.find('.carousel-slides__card').not('.is-selected').outerWidth()));
    
    var viewportWidth = 0;
    var viewportMove = 0;
    var activeSlideNum = 0;
    
    
    
    // cycle thru all the cards to calculate total width of viewport
    _this.find('.carousel-slides__card').each(function() {
        viewportWidth += $(this).outerWidth();
    })

    
    
    _this.find('.carousel-slides__carousel-viewport').css('width', viewportWidth);
    
    
    $(window).on('resize', debounce(windowResizeFuncs, 500)).trigger('resize');
    
    // show content of first slide on load
    if ( _this.find(".carousel-slides__card.is-selected .carousel-slides__content").length ) {
        gsap.to(_this.find(".carousel-slides__card.is-selected .carousel-slides__content"), {
            opacity: 1,
            duration: 1.25
        })
    }
    
    // add next and prev click events
    _this.find('.carousel-slides__card').on('swiped-left', {parent: _this, direction: 'next'}, changeSlide);
    _this.find('.carousel-slides__card').on('swiped-right', {parent: _this, direction:  'prev'}, changeSlide);
    _this.find('.carousel-slides__controls-button.next').on('click', {parent: _this, direction: 'next'}, changeSlide);
    _this.find('.carousel-slides__controls-button.previous').on('click', {parent: _this, direction:  'prev'}, changeSlide);

    _this.find('.carousel-slides__card').on('click', function() {
        if ( $(this).hasClass('is-selected') ) return;
        let data = {
            data: {
                parent: _this, 
                direction: 'click',
                selectedCard: $(this),
            }
        }
        changeSlide(data);
    })


    // when the window resizes, recalculate the card widths, the viewport width and run the resize function
    function windowResizeFuncs() {

        cardWidth = Math.round(parseFloat(_this.find('.carousel-slides__card').not('.is-selected').outerWidth()));
        // viewportWidth = 0;
        _this.find('.carousel-slides__card').each(function() {
            viewportWidth += $(this).outerWidth();
        })

        _this.find('.carousel-slides__carousel-viewport').css('width', viewportWidth);


        var cardHeight = 0;
        _this.find('.carousel-slides__card').each(function() {
            if ( $(this).height() > cardHeight ) {
                cardHeight = $(this).height();
            }
        })

        gsap.set(_this.find('.carousel-slides__carousel-viewport'), {
            height: cardHeight + 20
        })

        _this.find('.carousel-slides__controls-button.next').css('top', _this.find('.carousel-slides__card.is-selected').height() / 2 );
        _this.find('.carousel-slides__controls-button.previous').css('top', _this.find('.carousel-slides__card.is-selected').height() / 2 );

        resize();
    }



    function changeSlide(event) {
        var parent = event.data.parent;
        let activeSlide = parent.find('.carousel-slides__card.is-selected');
        var viewport = parent.find('.carousel-slides__carousel-viewport');
        
    
        // set new card based on direction
        let selectedCard = '';
        if ( event.data.direction == 'next' ) selectedCard = activeSlide.next();
        if ( event.data.direction == 'prev' ) selectedCard = activeSlide.prev();
        if ( event.data.direction == 'click' ) selectedCard = event.data.selectedCard;

        // if there isnt a next/prev slide do nothing
        if ( !selectedCard.length ) return;

        // update current slide number based on direction
        if ( event.data.direction == 'next' ) activeSlideNum++
        if ( event.data.direction == 'prev' ) activeSlideNum--
        if ( event.data.direction == 'click' ) activeSlideNum = parent.find('.carousel-slides__card').index(event.data.selectedCard);
        

        // animate the content
        gsap.to(activeSlide.find('.carousel-slides__content'), {
            opacity: 0,
            duration: 0.1,
        })

        // update selected card
        selectedCard.addClass('is-selected');
        activeSlide.removeClass('is-selected');
        let newActiveSlide = selectedCard;

        gsap.to(newActiveSlide.find('.carousel-slides__content'), {
            opacity: 1,
            duration: 1.25,
        }, '-=0.15');


        // calculate how far the viewport needs to move
        viewportMove = -Math.abs(activeSlideNum * cardWidth);

        gsap.to(viewport, {
            'x': viewportMove,
            duration: 1.25,
        });

        // update dots
        updateDots(activeSlideNum);
    }

    function updateDots(index) {

        // remove selected class from current dot and add it to new dot
        let dots = _this.find('.carousel-slides__page-dots');
        dots.find('.is-selected').removeClass('is-selected');
        dots.children().eq(index).addClass('is-selected');
    }

    function resize() {
        // calculate where the viewport should be based on which card is selected
        var viewport = _this.find('.carousel-slides__carousel-viewport');
        viewportMove = activeSlideNum * cardWidth;
        gsap.to(viewport, {
            x: -Math.abs(viewportMove),
        })
    }

    function debounce(func, delay) {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                func.apply(context, args);
            }, delay);
        };
    };
})
